var baseClassName = 'fi-link';
var linkClassNames = {
  linkUnderline: "".concat(baseClassName, "--initial-underline"),
  accent: "".concat(baseClassName, "--accent"),
  accentIcon: "".concat(baseClassName, "--accent_icon"),
  small: "".concat(baseClassName, "--small")
};

export { baseClassName, linkClassNames };
//# sourceMappingURL=BaseLink.js.map
